import React from 'react';
import './Contact.css';
import HighlightHeader from '../../assets/images/brush3.png';
import { Helmet } from 'react-helmet';


export default function ContactPage() {

    return (
    <>
        <Helmet>
        <title>Contact</title>
        </Helmet>
            <div className='contact-page'>
                <div className='survey-wrapper'>
                    <section className='contact-section'>
                            <div className='contact-wrapper'>
                                <div className='highlight-header-contact'>
                                    <img src={HighlightHeader} alt='highlighting texture'></img>
                            </div>
                            <h1>Contact Us</h1></div>
                            <p>
                            Use the form below to send us your questions or feedback.
                            </p>

                            <div className='qualtrics-wrapper'>
                                <iframe className ='qualtrics-contact'
                                        src='https://qualtricsxmv3vphggzh.qualtrics.com/jfe/form/SV_efTZGtxaTufNv2C' 
                                        title='qualtrics-iframe'
                                >
                                </iframe>
                            </div>
                            
                        </section>
                    
                </div>
            </div>
    </>
    )

}


